import { MessageType } from "constants/UserConstants";

export const isAttachment = (messageType) => {
  const attachmentTypes = [
    MessageType.DOCUMENT,
    MessageType.AUDIO,
    MessageType.IMAGE,
    MessageType.VOICE,
    MessageType.VIDEO,
  ];
  return attachmentTypes.includes(messageType);
};

export const getMessageTypeBasedOnFormat = (format) => {
  const documentFormats = ["PDF", "DOC", "DOCX", "PPT", "PPTX", "XLS", "XLSX"];
  const imageFormats = ["JPG", "PNG", "JPEG"];
  const audioFormats = ["AAC", "AMR", "MP3", "OPUS"];
  const videoFormats = ["MP4", "3GPP"];
  switch (true) {
    case documentFormats.includes(format):
      return MessageType.DOCUMENT;
    case imageFormats.includes(format):
      return MessageType.IMAGE;
    case audioFormats.includes(format):
      return MessageType.AUDIO;
    case videoFormats.includes(format):
      return MessageType.VIDEO;
    default:
      return MessageType.TEXT;
  }
};
